module.exports = __webpack_public_path__ + "static/media/03-news.6c03c4cf.png";